module.exports = __webpack_public_path__ + "assets/fullscreen.9ce971c6.svg";